import React, { memo } from "react";
import styled from "styled-components";
import { config } from "../../config";

interface IPropertyProps {
  name: string;
  value: string;
}

const AppPropertiesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  width: 100%;
`;

const AppPropertiesStyle = styled.div`
  background-color: lightGrey;
  color: #000;
  border-radius: 5px;
  padding: 15px 22px;
  width: 50%;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

const PropertyStyle = styled.div`
  padding-top: 5px;
  padding-bottom: 5px;
`;

const PropertyName = styled.span`
  padding: 10px;
  font-weight: bold;
`;

const Property = ({ name, value }: IPropertyProps) => {
  return (
    <PropertyStyle>
      <PropertyName>{`${name}: `}</PropertyName>
      <span data-test={`property-value-${name}`}>{value}</span>
    </PropertyStyle>
  );
};

const AppPropertiesDef = () => {
  return (
    <AppPropertiesWrapper data-test="app-properties">
      <AppPropertiesStyle>
        <Property name="VERSION" value={`${process.env.REACT_APP_VERSION}`} />
        <Property
          name="IB"
          value={`${process.env.REACT_APP_IB_API_BASE_URL}`}
        />
        <Property name="API" value={config.apiVersion} />
        <Property name="Backend" value={config.minBackendVersion} />
        <Property
          name="Locale"
          value={`${process.env.REACT_APP_DEFAULT_LOCALE}`}
        />
      </AppPropertiesStyle>
    </AppPropertiesWrapper>
  );
};

export const AppProperties = memo(AppPropertiesDef);
